import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TopVariablesService {

  public variables: Observable<any>;
  public varialeCollection: AngularFirestoreCollection<any>;

  constructor(
    private database: AngularFirestore
  ) {}

  public getDoc(): Observable<any> {
    this.varialeCollection = this.database.collection<any>('variables');
    this.variables = this.varialeCollection.valueChanges();
    return this.variables;
  }
}
